import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import { useAnalyticsImpressionsStore } from 'analytics/stores/analyticsImpressions'
import { useCallback, useMemo } from 'react'

export const useAnalyticsImpressions = () => {
	const addImpression = useAnalyticsImpressionsStore(
		(state) => state.addImpression
	)
	const resetImpressions = useAnalyticsImpressionsStore(
		(state) => state.resetImpressions
	)

	const { sendViewItemList } = useEECEvents()

	const flushImpressions = useCallback(async () => {
		// The current impressions are fetched directly from the store
		// to avoid unnecessary re-renders when impressions change
		const impressions = structuredClone(
			useAnalyticsImpressionsStore.getState().impressions
		)

		// If there are no impressions or the session ID is not available, do nothing
		if (impressions.length === 0 || !window.analytics?.sessionId) {
			return
		}

		resetImpressions()
		await sendViewItemList({ items: impressions })
	}, [resetImpressions, sendViewItemList])

	return useMemo(
		() => ({ addImpression, flushImpressions }),
		[addImpression, flushImpressions]
	)
}
